import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import styles from './styles.module.scss';

if (process.env.NODE_ENV !== 'test') Modal.setAppElement('#root');
const defaultMessage = 'Something went wrong. Try again later...';

const ErrorMessagePopUp = ({
                             showErrorMessage,
                             hideGlobalErrorMessage,
                             message = defaultMessage,
                             callback,
                           }) => {
  const handleHide = () => {
    Promise.resolve()
      .then(() => {
        if (Boolean(callback)) {
          callback();
        }
      })
      .then(() => {
        hideGlobalErrorMessage();
      })
  };

  return (
    <Modal
      isOpen={showErrorMessage}
      onRequestClose={handleHide}
      className={`${styles.modal} ${styles.rtl}`}
      overlayClassName={styles.overlay}
    >
      <div dir='rtl' className={styles.modalContainer}>
        <div className={styles.message}>
          {message}
        </div>
        <div onClick={handleHide} className={styles.button}>
          סגירה
        </div>
      </div>
    </Modal>
  );
};

ErrorMessagePopUp.propTypes = {
  showErrorMessage: PropTypes.bool,
  hideGlobalErrorMessage: PropTypes.func,
  message: PropTypes.string,
  callback: PropTypes.func,
};

export default ErrorMessagePopUp;
